
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";

/**
 * InventoryMetadataService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InventoryMetadataService {
    private readonly $apiService = inject(ApiService);
    
    GetAddInventoryMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IInventoryMetadataService/GetAddInventoryMetadata");
    }
}
